module.exports = __webpack_public_path__ + "img/logo.c5f86514.png";